import React, {useEffect, useState} from 'react';
import './MemoriesPage.css';
import {useLocation, useOutletContext, useNavigate} from 'react-router-dom';
import HighlightModal from '../HighlightModal/HighlightModal';
import { Typography } from '@mui/material';
import LoadingSpinner from "../../../../../shared/components/LoadingSpinner/LoadingSpinner";


const MemoriesPage = () => {

  const [modalOpen, setModalOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [pageLoading, setPageLoading] = useState(true);
  const { setContentLoaded = () => {} } = useOutletContext() || {};
  const navigate = useNavigate();

  const location = useLocation();
  const { images = [], year = '' } = location.state || {};

  const handleImageClick = (src) => {
    setSelectedImage(src);
    setModalOpen(true);
  }

  const handleClose = () => {
    setModalOpen(false);
    setSelectedImage(null);
  }

  useEffect(() => {
    if (!images || images.length === 0) {
      navigate('/Highlights', {
        state: {
          notification: 'Click on a folder to view images!'
        }
      });
    }
  }, [images, navigate]);

  useEffect(() => {
    const t = setTimeout(() => {
      setPageLoading(false);
      setContentLoaded(true);
    }, 1000);
    return () => clearTimeout(t);
  }, [setContentLoaded]);

  if (pageLoading) {
    return (
      <div style={{ margin: 'auto' }}>
        <LoadingSpinner />
      </div>
    );
  }

  return (
    <div className="MemoriesPage">
      <Typography variant='h3' align='center' className="year-title"  gutterBottom>
        🎉 {year} Memories 🎉
      </Typography>
      <div className="memoriesContainer">
        { images?.map((image, index) => (
          <div key={index} className='memoryItem' onClick={() => handleImageClick(image)}>
            <img src={image} alt={`Memory ${index + 1}`} className='memoryImage' />
          </div>
        ))}
      </div>
      {selectedImage && (
        <HighlightModal show={modalOpen} onhide={handleClose} imageSrc={selectedImage} />
      )}
    </div>
  );
}

export default MemoriesPage;